import { render, staticRenderFns } from "./ModalCookiePolicy.vue?vue&type=template&id=0eac49bd&scoped=true"
import script from "./ModalCookiePolicy.vue?vue&type=script&lang=js"
export * from "./ModalCookiePolicy.vue?vue&type=script&lang=js"
import style0 from "./ModalCookiePolicy.vue?vue&type=style&index=0&id=0eac49bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eac49bd",
  null
  
)

export default component.exports